import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
* This source code is quoted from rc-tabs.
* homepage: https://github.com/react-component/tabs
*/
import React from 'react';
import classnames from 'classnames';
import { getTransformByIndex, getActiveIndex, getTransformPropValue, getMarginStyle } from './utils';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
var TabContent = createClass({
  propTypes: {
    animated: PropTypes.bool,
    animatedWithMargin: PropTypes.bool,
    clsPrefix: PropTypes.string,
    children: PropTypes.any,
    activeKey: PropTypes.string,
    style: PropTypes.any,
    tabBarPosition: PropTypes.string
  },
  getDefaultProps: function getDefaultProps() {
    return {
      animated: true
    };
  },
  getTabPanes: function getTabPanes() {
    var props = this.props;
    var activeKey = props.activeKey;
    var children = props.children;
    var newChildren = [];
    React.Children.forEach(children, function (child) {
      if (!child) {
        return;
      }

      var key = child.key;
      var active = activeKey === key;
      newChildren.push( /*#__PURE__*/React.cloneElement(child, {
        active: active,
        destroyInactiveTabPane: props.destroyInactiveTabPane,
        rootclsPrefix: props.clsPrefix
      }));
    });
    return newChildren;
  },
  render: function render() {
    var _classnames;

    var props = this.props;
    var clsPrefix = props.clsPrefix,
        children = props.children,
        activeKey = props.activeKey,
        tabBarPosition = props.tabBarPosition,
        animated = props.animated,
        animatedWithMargin = props.animatedWithMargin;
    var style = props.style;
    var classes = classnames((_classnames = {}, _defineProperty(_classnames, "".concat(clsPrefix, "-content"), true), _defineProperty(_classnames, animated ? "".concat(clsPrefix, "-content-animated") : "".concat(clsPrefix, "-content-no-animated"), true), _classnames));

    if (animated) {
      var activeIndex = getActiveIndex(children, activeKey);

      if (activeIndex !== -1) {
        var animatedStyle = animatedWithMargin ? getMarginStyle(activeIndex, tabBarPosition) : getTransformPropValue(getTransformByIndex(activeIndex, tabBarPosition));
        style = _objectSpread(_objectSpread({}, style), animatedStyle);
      } else {
        style = _objectSpread(_objectSpread({}, style), {}, {
          display: 'none'
        });
      }
    }

    return /*#__PURE__*/React.createElement("div", {
      className: classes,
      style: style
    }, this.getTabPanes());
  }
});
export default TabContent;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-tabs/src/TabContent.js